import { Component, Input, OnInit } from '@angular/core';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { Observable } from 'rxjs';
import { DashService } from '../../dash-board/dash.service';
import { MENU_ITEMS } from './menu-items.const';
import { MessageService } from '@services/util/message.service';
import { ApiService } from '@services/api/api.service';
import { UserActivityAccessService } from '@services/user-activity/user-activity-access.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @Input() isLead: boolean = false;
  @Input() isTask: boolean = false;
  @Input() isSetting: boolean = false;
  @Input() isProject: boolean = false;
  @Input() isSale: boolean = false;
  @Input() margin: any;
  @Input() isListing: boolean = false;
  @Input() isProperty: boolean = false;
  @Input() isApproval: boolean = false;
  @Input() isOfi: boolean = false;
  @Input() fromLead: boolean = true;
  @Input() tab_view: Observable<any> = null;
  @Input() listing_count: any;
  /**
   * The Remmi Releases banner sits under this tab strip on every page that uses it. Pages that lay
   * the menu out inside a row with other controls turn it off here and place the banner themselves.
   */
  @Input() showReleaseBanner: boolean = true;

  public menuItems = MENU_ITEMS;
  private userRole = '';
  private canViewUserActivity = false;

  constructor(
    public lmService: LeadManagementService,
    public message: MessageService,
    private dash: DashService,
    private api: ApiService,
    private userActivityAccess: UserActivityAccessService
  ) {
    this.userRole = (this.api.getRole() || '').toString().toLowerCase();
  }

  approval_tab = null;
  mobToggle = false;

  /** Hide role-restricted items (e.g. the login activity dashboard) from other roles. */
  isItemRoleAllowed(item: any): boolean {
    if (!item?.roles?.length) {
      return true;
    }
    return item.roles.includes(this.userRole);
  }

  isItemAllowed(item: any): boolean {
    return this.isItemRoleAllowed(item) && (!item?.userActivityAccess || this.canViewUserActivity);
  }

  ngOnInit() {
    if (this.isSale) {
      // The access call completes after one value (it is cached per user), so there is nothing to tear down.
      this.userActivityAccess.access$.subscribe(access => (this.canViewUserActivity = access.can_view));
    }
    // subscribe to the tab view observable
    this.tab_view?.subscribe(rex => {
      // update the approval tab value
      this.approval_tab = rex;
    });

    // subscribe to the screen size observable
    this.dash?.screenSize$?.subscribe(size => {
      // if the screen width is less than 567, set the mobile toggle to true

      if (size.width < 567) {
        this.mobToggle = true;
      } else {
        // otherwise, set the mobile toggle to false
        this.mobToggle = false;
      }
    });
  }

  loadProject() {
    this.message.sendMessage({ loadProject: true });
  }
}
